module.exports = __webpack_public_path__ + "img/GanzSchönFrech.0e0056dc.svg";